module.exports = __webpack_public_path__ + "static/media/2DGACM14.8e5b0bab.jpg";